export default __webpack_public_path__ + "static/media/left.ff88d4b1.txt";